<template>
  <div class="status-layout">
    <h5 class="title">Payment Gateway Status</h5>
    <h6>Current Status: <b>{{status}}</b></h6>
    <p v-html="description"></p>

    <!-- <button
      v-if="getterPgStatus === 'not_applicable'"
      class="dark-btn"
      @click="requestAccess"
    >
      Request Access
    </button> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PgStatus',
  data () {
    return {
      status: null,
      description: null
    }
  },
  computed: {
    ...mapGetters(['getterPgStatus'])
  },
  watch: {
    getterPgStatus: {
      handler: 'populateData',
      immediate: true
    }
  },
  methods: {
    populateData () {
      if (!this.getterPgStatus) {
        return
      }

      this.status = this.getterPgStatus.toUpperCase().replace('_', ' ')

      switch (this.getterPgStatus) {
        case 'not_applicable':
          this.description = `We have introduced a new feature <b>Payment Gateway</b>.<br>To enable the feature please click the 'Request Access' button.`
          break
        case 'inactive':
          this.description = `Your Payment Gateway feature request is in processing. Will let you know via email after your request has been approved.`
          break
      }

      this.description += `<br>For any queries please write to <a href="mailto:support@hypto.in">support@hypto.in</a>.`
    },
    requestAccess () {

    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .status-layout {
    background: $white;
    border-radius: 15px;
    text-align: left;

    .title {
      @include highlight-text($secondary, 16px);
    }
    h6 {
      @include normal-text($secondary, 16px);
      margin: 30px 0 15px;

      b {
        color: $primary;
        margin-left: 5px;
      }
    }
    p {
      @include normal-text($grey-text, 14px, 400);
      line-height: 30px;
      margin-bottom: 20px;
    }
  }

  .desktop {
    .status-layout {
      width: 50%;
      padding: 25px;
      height: calc(100vh - 100px);
    }
  }

  .mobile, .tablet {
    .status-layout {
      padding: 15px;
    }
  }
</style>
